import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import paths from "../Router/paths"

export default function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    // don't scroll to top on these routes
    if (pathname === paths.policiesPage.path || pathname === paths.privacyPage.path || pathname === paths.cancellationPage.path || pathname === paths.contactPage.path) {
      document.documentElement.style.scrollBehavior = "auto"
      document.documentElement.style.transform = "translateY(0px)"
      document.body.style.transform = "translateY(0px)"
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      setTimeout(() => {
        document.documentElement.style.scrollBehavior = ""
      }, 0)
    } else {
      window.scrollTo(0, 0)
    }
  }, [pathname])
  return null
}
